"use strict";

exports.__esModule = true;
exports.DeviceDataTableWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _ChartCard = require("../common/ChartCard");
var _reactIntl = require("react-intl");
var _DeviceDataTableElement = require("./DeviceDataTableElement");
var _DeviceDataTableFields = require("./DeviceDataTableFields");
var _DeviceDataTableThumbnail = require("./DeviceDataTableThumbnail");
var _EditableDeviceDataTableElement = require("./EditableDeviceDataTableElement");
var _widgetGroups = require("../widgetGroups");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
//This widget is deprecated. It should not be used in ui elevate widget list
var DeviceDataTableWidget = exports.DeviceDataTableWidget = {
  name: "DeviceDataTable",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "DeviceDataTableWidget.label",
    defaultMessage: "MTC Multi Data Table"
  }),
  icon: "th-list",
  group: _widgetGroups.RAW_DATA_WIDGET,
  createElement: function createElement(props) {
    return {
      type: "DeviceDataTable",
      props: Object.assign({
        dataSource: "",
        dataRange: "",
        width: 512,
        height: 512
      }, props),
      children: []
    };
  },
  showInPalette: true,
  isParent: true,
  requiresContexts: [],
  suppliesContexts: [],
  optionalProps: ["fontFamily", "fontSize", "fontWeight", "fontStyle", "textDecoration", "textAlignment", "color", "onClickAction"],
  requiresProps: ["x", "y", "width", "height"],
  suppliesProps: [],
  propConstraints: {
    width: {
      "default": 320,
      min: 32,
      max: 1024
    },
    height: {
      "default": 320,
      min: 32,
      max: 768
    }
  },
  components: {
    Editable: _EditableDeviceDataTableElement.EditableDeviceDataTableElement,
    Element: (0, _ChartCard.withChartCard)(_DeviceDataTableElement.DeviceDataTableElement),
    Fields: _DeviceDataTableFields.DeviceDataTableFields,
    Thumbnail: _DeviceDataTableThumbnail.DeviceDataTableThumbnail
  }
};